import React, { useState } from 'react'
import { cars } from '../../utilits/bookingCars'
import { icons } from '../../utilits/icons'
import './Booking.css'

export default function Booking() {

  const [activeLike, setActiveLike] = useState({})

  return (
    <div className='booking'>
      <div className="booking-container">
        <h1>Booking</h1>
        <div className="booking-car">
          {
            cars.map((element, value) =>{
              return <div className='booking-car_card'>
                <div className="booking-card_top">
                  <h3>Porshe 718 Cayman S</h3>
                  <button className={activeLike === element.icon ? 'activeLike' : ''}  key={value}                    onClick={()=> setActiveLike(element.icon)}>{element.icon}</button>
                </div>
                <h4 className='booking-card_text'>Coupe</h4>
                <div className="booking-image">
                  <img src={element.image} alt="" />
                </div>
                <div className="booking-card_bottom">
                  <div className="cards-bottom_left">
                    <p>{icons.person}</p>
                    <span>4</span>
                    <p className='second-icon'>{icons.repeatSquare}</p>
                    <span>Manual</span>
                  </div>
                  <h4>$400<span>/d</span></h4>
                </div>
              </div>
            })
          }
        </div>
      </div>
    </div>
  )
}
